import script from "./assessment-info.vue?vue&type=script&setup=true&lang=js"
export * from "./assessment-info.vue?vue&type=script&setup=true&lang=js"

import "./assessment-info.vue?vue&type=style&index=0&id=acbfec4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acbfec4c"]])

export default __exports__